// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__1dP-0","Logo":"Toolbar_Logo__3Rz6Y","DesktopOnly":"Toolbar_DesktopOnly__3vu8E"};